export class GcpSapHanaResource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "instances",
            "baseName": "instances",
            "type": "Array<SapHanaInstance>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpSapHanaResource.attributeTypeMap;
    }
    constructor() {
    }
}
